import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qualitymandates',
  templateUrl: './qualitymandates.component.html',
  styleUrls: ['./qualitymandates.component.scss']
})
export class QualitymandatesComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
